import type { ApiResponse, PaymentMethods } from '../../types/api';

import { baseApi } from './baseApi';


interface UpdatePaymentMethodRequest {
  walletNumber?: string;
  walletNumbers?: string[];
  merchantId?: string;
  apiKey?: string;
  secretKey?: string;
  walletAddress?: string;
  accessId?: string;
  adminEmail?: string;
  coin?: string;
}

export const paymentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentMethods: builder.query<ApiResponse<{ paymentMethods: PaymentMethods }>, void>({
      query: () => ({
        url: '/payments/methods',
        method: 'GET',
      }),
      providesTags: ['PaymentMethod'],
    }),
    updatePaymentMethod: builder.mutation<
      ApiResponse<{ message: string }>,
      { method: 'Syriatel' | 'Sham' | 'Payeer' | 'Cryptomus' | 'OxaPay' | 'Binance' | 'CoinEx'; data: UpdatePaymentMethodRequest }
    >({
      query: ({ method, data }) => ({
        url: `/payments/methods/${method}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['PaymentMethod', 'Settings'],
    }),
  }),
});

export const { useGetPaymentMethodsQuery, useUpdatePaymentMethodMutation } = paymentsApi;
